// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container-wrapper.hop-auth-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.main-container-wrapper.hop-auth-wrapper p {
  margin-bottom: 20px;
  padding-bottom: 5px;
  border-bottom: 1px #0abf53 solid;
}
.main-container-wrapper.hop-auth-wrapper a {
  font-size: 20px;
}
.main-container-wrapper.hop-auth-wrapper strong {
  font-weight: bold;
}
.main-container-wrapper.hop-auth-wrapper h2 {
  font-size: 36px;
  padding-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/HOPAuth/HOPAuth.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AADF;AAEE;EACE,mBAAA;EACA,mBAAA;EACA,gCAAA;AAAJ;AAEE;EACE,eAAA;AAAJ;AAEE;EACE,iBAAA;AAAJ;AAEE;EACE,eAAA;EACA,oBAAA;AAAJ","sourcesContent":["@import \"./../../utils/scss/variables\";\n\n.main-container-wrapper.hop-auth-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  p {\n    margin-bottom: 20px;\n    padding-bottom: 5px;\n    border-bottom: 1px $primary-color solid;\n  }\n  a {\n    font-size: 20px;\n  }\n  strong {\n    font-weight: bold;\n  }\n  h2 {\n    font-size: 36px;\n    padding-bottom: 20px;\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
